import { render } from "./BreakForm.vue?vue&type=template&id=08717a29&scoped=true"
import script from "./BreakForm.vue?vue&type=script&lang=js"
export * from "./BreakForm.vue?vue&type=script&lang=js"

import "./BreakForm.vue?vue&type=style&index=0&id=08717a29&scoped=true&lang=css"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08717a29"]])

export default __exports__